import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";

import { CommonModule, NgIf } from "@angular/common";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { COOKIE_PREFIX } from "src/environments/environment";
import {
  EMAIL_PATTERN,
  WHOLE_NUMBER_PATTERN,
} from "../../../config/app.constants";
import { Globals } from "../../../globals";
import { AuthService } from "../../../shared/services/auth.service";
import { CartsService } from "../../../shared/services/carts.service";
import { LoginService } from "../../../shared/services/login.service";
import { Utils } from "../../../shared/utils";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    NgIf,
    RouterLink,
  ],
})
export class RegistrationComponent implements OnInit {
  submitted: boolean = false;
  isRegister: boolean = false;
  userData: any = [];
  switchDetails: any = { switch_back: "" };
  chekoutFlag = false;
  cartDetails: any = [{ items: [] }];
  jwtHelper = new JwtHelperService();
  nextPage: string = "";
  showHidePassword: boolean = false;
  showHideConfirmPassword: boolean = false;

  addUser: FormGroup;
  first_name = new FormControl("", [Validators.required]);
  last_name = new FormControl("", [Validators.required]);
  email = new FormControl("", [
    Validators.required,
    Validators.pattern(EMAIL_PATTERN),
  ]);
  hear_about_us = new FormControl("", {});
  password = new FormControl("", [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(20),
  ]);
  password_confirmation = new FormControl("", [Validators.required]);
  phone_no = new FormControl("", [
    Validators.required,
    Validators.pattern(WHOLE_NUMBER_PATTERN),
    Validators.minLength(6),
    Validators.maxLength(15),
  ]);
  home_phone = new FormControl("", [Validators.pattern(WHOLE_NUMBER_PATTERN)]);
  country = new FormControl({ value: "United States", disabled: true }, [
    Validators.required,
  ]);
  state = new FormControl("", [Validators.required]);
  city = new FormControl("", [Validators.required]);
  zipcode = new FormControl("", [
    Validators.required,
    Validators.pattern(WHOLE_NUMBER_PATTERN),
    Validators.minLength(5),
    Validators.maxLength(9),
  ]);
  address = new FormControl("", [Validators.required]);
  tdl = new FormControl("", [Validators.pattern(WHOLE_NUMBER_PATTERN)]);
  term_condition = new FormControl(true, [Validators.requiredTrue]);

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router,
    public cartsService: CartsService,
    public globals: Globals,
    public loginService: LoginService
  ) {
    const token = localStorage.getItem(`${COOKIE_PREFIX}_token`);
    if (token) {
      this.router.navigate(["/"]);
    }
  }

  ngOnInit() {
    this.initUser();
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    setTimeout(() => {
      window.scroll(100, 100);
    }, 0);
  }

  initUser() {
    this.addUser = this.formBuilder.group(
      {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        hear_about_us: this.hear_about_us,
        password: this.password,
        password_confirmation: this.password_confirmation,
        phone_no: this.phone_no,
        home_phone: this.home_phone,
        country: this.country,
        state: this.state,
        city: this.city,
        zipcode: this.zipcode,
        address: this.address,
        tdl: this.tdl,
        term_condition: this.term_condition,
      },
      {
        validator: Utils.MustMatch("password", "password_confirmation"),
      }
    );
  }

  /**
   * This method is the show or hide password
   * */
  passwordShowHide() {
    this.showHidePassword = !this.showHidePassword;
  }

  /**
   * This method is the show or hide confirm-password
   * */
  confirmPasswordShowHide() {
    this.showHideConfirmPassword = !this.showHideConfirmPassword;
  }

  saveUserData() {
    this.submitted = true;
    if (this.addUser.valid) {
      this.isRegister = true;
      this.addUser.value.guest_id = sessionStorage.getItem("guest_id");
      this.nextPage = sessionStorage.getItem("nextPage");
      this.auth.register(this.addUser.value).subscribe(
        (res) => {
          this.submitted = false;
          this.isRegister = false;
          this.loginService.userData.push(this.globals.currentUser);
          if (res) {
            this.addUser.reset();
            if (this.nextPage === "checkout") {
              this.router.navigate(["checkout"]);
            } else {
              this.router.navigate(["/"]);
            }
          } else {
            return false;
          }
        },
        (error) => {
          this.submitted = false;
          this.isRegister = false;
        }
      );
    } else {
      return false;
    }
  }
}
